import React from 'react';
import { string, func } from 'prop-types';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import AddressEditor from '../../../../../../../AddressEditor';

export const getMandateInfos = ({
  i18n, orderId, dateOfSignature, type,
}) => {
  const mandateNameLabelText = type === 'EUDD'
    ? 'checkout.lib.components.payment.echeck.creditorName'
    : 'checkout.lib.components.payment.echeck.recipientName';
  const mandateAddressLabelText = type === 'EUDD'
    ? 'checkout.lib.components.payment.echeck.creditorAddress'
    : 'checkout.lib.components.payment.echeck.recipientAddress';
  return new Map([
    [ 'orderId', [ i18n('checkout.lib.components.payment.echeck.umr'), orderId ]],
    [ 'creditorIdentifier', [ i18n('checkout.lib.components.payment.echeck.creditorIdentifier'), 'GB05ACNSDDCHAS00000041317125' ]],
    [ 'mandateName', [ i18n(mandateNameLabelText), i18n('checkout.lib.components.payment.echeck.activeNetworkLLC') ]],
    [ 'mandateAddress', [ i18n(mandateAddressLabelText), {
      line1: i18n('checkout.lib.components.payment.echeck.line1'),
      line2: i18n('checkout.lib.components.payment.echeck.line2'),
      stateProvince: 'TX',
      city: i18n('checkout.lib.components.payment.echeck.city'),
      postalCode: '75080',
      country: 'US',
    }]],
    [ 'typeOfPayment', [ i18n('checkout.lib.components.payment.echeck.typeOfPayment'), i18n('checkout.lib.components.payment.echeck.oneOffPayment') ]],
    [ 'dateOfSignature', [ i18n('checkout.lib.components.payment.echeck.dateOfSignature'), dateOfSignature ]],
  ]);
};

const MandateFields = (params) => {
  const mandateInfos = getMandateInfos(params);
  const { type } = params;
  return (
    <div className="mandate-fields">
      {
        Array.from(mandateInfos.keys()).map((key) => {
          const info = mandateInfos.get(key) || [];
          if (type !== 'EUDD' && (key === 'orderId' || key === 'creditorIdentifier')) {
            return;
          }
          // eslint-disable-next-line consistent-return
          return <>
            <div className='mandate-field-label'>
              {info[0]}
            </div>
            <div className='mandate-field-val'>
              {
                key === 'mandateAddress'
                  ? <AddressEditor value={info[1]} static />
                  : info[1]
              }
            </div>
          </>;
        })
      }
    </div>
  );
};

MandateFields.propTypes = {
  type: string.isRequired,
  i18n: func.isRequired,
  dateOfSignature: string,
  orderId: string,
};

export default withI18n(MandateFields);
